import { useState, useEffect, useCallback } from "react";

const DEFAULT_STORAGE_KEY = "admin_customer_filter";

interface UseCustomerFilterOptions {
  storageKey?: string;
}

export function useCustomerFilter(options?: UseCustomerFilterOptions) {
  const storageKey = options?.storageKey ?? DEFAULT_STORAGE_KEY;
  const [customerIds, setCustomerIdsState] = useState<string[]>([]);

  // Load customer IDs from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        // Validate that it's an array of strings
        if (Array.isArray(parsed) && parsed.every((id) => typeof id === "string")) {
          setCustomerIdsState(parsed);
        }
      }
    } catch (error) {
      // Handle invalid JSON gracefully
      console.warn("Failed to parse customer filter from localStorage:", error);
      setCustomerIdsState([]);
    }
  }, [storageKey]);

  const setCustomerIds = useCallback(
    (ids: string[]) => {
      setCustomerIdsState(ids);
      localStorage.setItem(storageKey, JSON.stringify(ids));
    },
    [storageKey],
  );

  const clearCustomerIds = useCallback(() => {
    setCustomerIdsState([]);
    localStorage.removeItem(storageKey);
  }, [storageKey]);

  return {
    customerIds,
    setCustomerIds,
    clearCustomerIds,
  };
}
